import { string } from 'prop-types';
import React from 'react';

const Divider = ({ className }) => {
	return <div className={`divider-border ${className}`}></div>;
};

Divider.propTypes = {
	className: string
};

export default Divider;
